import { cn } from "@/common/utils/css.utils";
import { useProProjectsCopy } from "@/features/pro-buyer-projects/hooks/useProProjectsCopy";
import { useProProjectsNewLabel } from "@/features/pro-buyer-projects/hooks/useProProjectsNewLabel";
import { NewLabel } from "@/ui/cva/NewLabel";

/** WHO-5959 6b, spec S1: the pink "Nieuw" pill next to Pro Buyer-projecten in the account menus. */
export const ProProjectsMenuNewLabel = ({
  className,
}: {
  className?: string;
}) => {
  const { tc } = useProProjectsCopy();
  const visible = useProProjectsNewLabel();

  if (!visible) {
    return null;
  }

  return (
    <NewLabel className={cn("ml-2", className)}>{tc("newLabel")}</NewLabel>
  );
};
